import * as React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { BatteryTracking, DisabledTracking } from "../../../model/device";
import { useSupportedDevicesData } from "../../../hooks/use_site";

export default function BatteryTrackingSelect({ batteryType, value, onChange, disabled = false }) {
  const { data: supportedDevices } = useSupportedDevicesData();

  function disabled_mode(mode) {
    const batteryConfig = supportedDevices?.battery?.find((b) => b.device_type == batteryType);

    if (batteryConfig?.raw) {
      try {
        const rawConfig = typeof batteryConfig.raw === "string" ? JSON.parse(batteryConfig.raw) : batteryConfig.raw;
        if (rawConfig?.disabled_tracking) {
          return rawConfig.disabled_tracking.includes(mode);
        }
      } catch (error) {
        console.error("Failed to parse raw config for", batteryType, error);
      }
    }

    // Fall back to hardcoded DisabledTracking
    if (DisabledTracking[batteryType]) {
      return DisabledTracking[batteryType].includes(mode);
    }

    return false;
  }

  return (
    <FormControl fullWidth>
      <InputLabel>Battery tracking mode</InputLabel>
      <Select
        value={value}
        label="Battery tracking mode"
        disabled={disabled}
        onChange={(event) => {
          onChange(event);
        }}
      >
        <MenuItem
          key={BatteryTracking.GRID}
          value={BatteryTracking.GRID}
          disabled={disabled_mode(BatteryTracking.GRID)}
        >
          GRID
        </MenuItem>
        <MenuItem
          key={BatteryTracking.HYBRID}
          value={BatteryTracking.HYBRID}
          disabled={disabled_mode(BatteryTracking.HYBRID)}
        >
          HYBRID
        </MenuItem>
        <MenuItem
          key={BatteryTracking.INTERNAL}
          value={BatteryTracking.INTERNAL}
          disabled={disabled_mode(BatteryTracking.INTERNAL)}
        >
          INTERNAL
        </MenuItem>
        <MenuItem
          key={BatteryTracking.DISABLED}
          value={BatteryTracking.DISABLED}
          disabled={disabled_mode(BatteryTracking.DISABLED)}
        >
          DISABLED
        </MenuItem>
      </Select>
    </FormControl>
  );
}
